// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopPaymentListRequestModel from '../../model/get-shop-payment-list-request-model';
import GetShopPaymentListRequestDTO from '../dto/get-shop-payment-list-request-dto';
import dtoSchema from '../schemas/get-shop-payment-list-request-schema';

export default abstract class GetShopPaymentListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopPaymentListRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopPaymentListRequestDTO>): GetShopPaymentListRequestModel;
  static toModel(dto: DeepPartial<GetShopPaymentListRequestDTO> | undefined | null): GetShopPaymentListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopPaymentListRequestDTO> | undefined | null): GetShopPaymentListRequestModel | undefined {
    return dto ? new GetShopPaymentListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopPaymentListRequestModel> | GetShopPaymentListRequestModel): GetShopPaymentListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopPaymentListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopPaymentListRequestModel, can not map to GetShopPaymentListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
